<template>
  <div class="c-table" ref="table">
    <el-table v-loading="loading" :data="data" :height="height" class="common-el-table-styles" border stripe @selection-change="select">
      <el-table-column type="selection" width="30"></el-table-column>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'control'">
            <el-button v-if="hasAccountEdit" type="text" size="small" @click="$emit('on-edit-account', scope.row)">编辑</el-button>
            <el-button
              v-if="hasAccountGetAuth && scope.row.authorizedAddr"
              type="text"
              size="small"
              @click="openAuthWindow(scope.row.authorizedAddr)"
              >去授权</el-button
            >
          </div>
          <div v-else-if="col.key === 'switch'">
            <i-Switch
              v-model="scope.row.status"
              :loading="scope.row.optLoading"
              :true-value="1"
              :false-value="0"
              @on-change="$emit('on-switch', scope.row)"
              size="small"
            />
          </div>
          <div v-if="col.key === 'adAccount'">
            <el-button type="text" size="small" @click="$emit('on-show', scope.row)">{{ scope.row[col.key] }}</el-button>
          </div>
          <span v-else-if="col.key === 'accountType'">{{ scope.row[col.key] | convertAccountType }}</span>
          <span v-else-if="col.key === 'status'">{{ scope.row[col.key] | convertAccountStatus }}</span>
          <span v-else-if="col.key === 'settleType'">{{ scope.row[col.key] | convertSettle }}</span>
          <span v-else-if="col.key === 'updateTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else-if="col.key === 'createTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'AccountManageTable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  },
  computed: {
    hasAccountEdit() {
      return this.access.includes('M20888')
    },
    hasAccountGetAuth() {
      return this.access.includes('M20889')
    }
  },
  methods: {
    select(val) {
      this.$emit('on-select', val)
    },
    openAuthWindow(addr) {
      window.open(addr)
    }
  },
  data() {
    return {
      access: this.$store.state.accessAuth
    }
  },
  mounted() {},
  filters: {
    convertAccountType(originVal) {
      switch (originVal) {
        case 0:
          return '普通账号'
        case 1:
          return '管家账号'
        case 2:
          return '智投账号'
        default:
          return '-'
      }
    },
    convertAccountStatus(originVal) {
      switch (originVal) {
        case 0:
          return '无效'
        case 1:
          return '有效'
      }
    },
    convertSettle(originVal) {
      switch (originVal) {
        case 1:
          return '按消耗结算'
        case 2:
          return '按余额结算'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  position: relative;
  // height: calc(100% - 0px);
  background-color: #fff;
  z-index: 9;

  .el-table {
    // height: 100%;
  }
}
</style>
